import { ToastProvider, ToastViewport } from '@radix-ui/react-toast'
import type { LinksFunction, LoaderFunctionArgs } from '@remix-run/node'
import { json } from '@remix-run/node'
import {
  Links,
  Meta,
  Outlet,
  Scripts,
  ScrollRestoration,
  useLoaderData,
  useLocation,
  useNavigation,
} from '@remix-run/react'
import { useEffect } from 'react'
import { PaymentCardProvider } from './design-system/components/CreditCart/Provider'
import { Emarsys } from './Emarsys/Emarsys'
import { env } from './env'

import globalCssURL from './globals.css?url'

import { DataLayerProvider } from './GTM/DataLayerGTM'
import { Loading } from '~/design-system/primitives'

export function RouteTracker() {
  const location = useLocation()

  useEffect(() => {
    const currentPath = sessionStorage.getItem('currentPath')
    if (location.pathname !== '/access') {
      sessionStorage.setItem('lastPath', currentPath || '/')
    }
    sessionStorage.setItem('currentPath', location.pathname)
  }, [location.pathname])

  return null
}

export const links: LinksFunction = () => [
  {
    rel: 'icon',
    href: '/favicon.ico',
    type: 'image/x-icon',
  },
  { rel: 'stylesheet', href: globalCssURL },

  // {
  //   rel: 'preload',
  //   href: '/fonts/MaterialSymbolsOutlined.woff2',
  //   as: 'font',
  //   type: 'font/woff2',
  //   crossOrigin: 'anonymous',
  // },
  {
    rel: 'preload',
    href: '/fonts/AvenirNext-Medium.woff2',
    as: 'font',
    type: 'font/woff2',
    crossOrigin: 'anonymous',
  },
  {
    rel: 'preload',
    href: '/fonts/AvenirNext-Regular.woff2',
    as: 'font',
    type: 'font/woff2',
    crossOrigin: 'anonymous',
  },
]

export async function loader({ request }: LoaderFunctionArgs) {
  return json({
    ENV: {
      GTM_CONTAINER_ID: env?.GTM_CONTAINER_ID,
      GTM_SOURCE: env?.GTM_SOURCE,
      VTEX_STORE_ID: env?.VTEX_STORE_ID,
      VTEX_COOKIE_CHECKOUT: env.VTEX_COOKIE_CHECKOUT,
      EMARSYS_MERCHANT_ID: env.EMARSYS_MERCHANT_ID,
      EMARSYS_MERCHANT_APPLICATION_CODE: env.EMARSYS_MERCHANT_APPLICATION_CODE,
      EMARSYS_MERCHANT_SAFARI_WEBSITE_PUSH_ID: env.EMARSYS_MERCHANT_SAFARI_WEBSITE_PUSH_ID,
      EMARSYS_MERCHANT_APPLICATION_SERVER_PUBLIC_KEY: env.EMARSYS_MERCHANT_APPLICATION_SERVER_PUBLIC_KEY,
      UTMI_PAGE: env.UTMI_PAGE,
      IS_ACTIVE_CASHBACK: env.IS_ACTIVE_CASHBACK,
      EXTRACT_LOYALTY_2: env.EXTRACT_LOYALTY_2
    },
  })
}

export function Layout({ children }: { children: React.ReactNode }) {
  const env = useLoaderData<typeof loader>()

  return (
    <html lang="en">
      <head>
        <meta charSet="utf-8" />
        <meta content="width=device-width, initial-scale=1" name="viewport" />
        <Meta />
        <Links />
      </head>
      <body className="font-sans text-primary-black">
        <DataLayerProvider ENV={env?.ENV} />
        <Emarsys ENV={env?.ENV} />

        <PaymentCardProvider>
          <ToastProvider swipeDirection="up">
            {children}
            <ToastViewport className="fixed top-0 right-0 flex flex-col p-6 gap-2.5 w-screen m-0 list-none z-50 outline-none justify-center" />
          </ToastProvider>

        </PaymentCardProvider>

        <script
          dangerouslySetInnerHTML={{
            __html: `window.ENV = ${env?.ENV ? JSON.stringify(env?.ENV) : {}}`,
          }}
        />

        <Scripts />

        <ScrollRestoration />
      </body>
    </html>
  )
}

export default function App() {
  const navigation = useNavigation()

  return (
    <>
      <Outlet />
      {navigation.state != 'idle' && <Loading />}
    </>
  )
}
